export const Roles = {
  SUDO: 'SUDO',
  ADMIN: 'ADMIN',
  ADMIN_BIO: 'ADMIN_BIO',
  APROVADOR: 'APROVADOR',
  SOLICITANTE: 'SOLICITANTE',
  PONTO_ATENDIMENTO: 'PONTO_ATENDIMENTO',
};

const roleHierarchy = [
  Roles.SUDO,
  Roles.ADMIN,
  Roles.ADMIN_BIO,
  Roles.APROVADOR,
  Roles.SOLICITANTE,
  Roles.PONTO_ATENDIMENTO,
];

export function getHighestRole() {
  const user = getCurrentUser();
  if (!user || !user.perfis) return null;

  for (const role of roleHierarchy) {
    if (user.perfis.includes(role)) {
      return role;
    }
  }

  return null;
}

export function getCurrentUser() {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (e) {
    console.error('Erro ao obter usuário do localStorage:', e);
    return null;
  }
}

export function hasRole(role) {
  const user = getCurrentUser();
  return user && user.perfis && user.perfis.includes(role);
}

export function hasAnyRole(roles = []) {
  const user = getCurrentUser();
  if (!user || !user.perfis) return false;
  return roles.some((role) => user.perfis.includes(role));
}

export function hasClienteComPA() {
  const user = getCurrentUser();
  return user && user.cliente && user.cliente.possuiPontoAtendimento === true;
}

export function isSudo() {
  return getHighestRole() === Roles.SUDO;
}

export function isAdminBio() {
  return getHighestRole() === Roles.ADMIN_BIO;
}

export function isAdmin() {
  return getHighestRole() === Roles.ADMIN;
}

export function isAprovador() {
  return getHighestRole() === Roles.APROVADOR;
}

export function isSolicitante() {
  return getHighestRole() === Roles.SOLICITANTE;
}

export function isPontoAtendimento() {
  return getHighestRole() === Roles.PONTO_ATENDIMENTO;
}
